import ImageDropField from "./ImageDropField";

export default function PackageEditor({ packages, onChange, onFileUpload, onSave, saving }) {
  const updatePackage = (index, field, value) => {
    const next = [...packages];
    next[index] = { ...next[index], [field]: value };
    onChange(next);
  };

  return (
    <div className="admin-edit-list" data-testid="admin-packages-panel">
      {packages.map((pack, index) => (
        <article key={`${pack.name}-${index}`} data-testid={`package-editor-${index + 1}`}>
          <div className="package-editor-grid">
            <label>Paket adı<input value={pack.name} onChange={(event) => updatePackage(index, "name", event.target.value)} data-testid={`package-name-input-${index + 1}`} /></label>
            <label>Görsel bağlantısı<input value={pack.image || ""} onChange={(event) => updatePackage(index, "image", event.target.value)} data-testid={`package-image-url-input-${index + 1}`} /></label>
            <ImageDropField image={pack.image} label="Görseli sürükleyin veya seçin" onFileUpload={(file) => onFileUpload(index, file)} inputTestId={`package-image-upload-input-${index + 1}`} rootTestId={`package-image-dropzone-${index + 1}`} />
            <label>Fiyat<input placeholder="Örn. 18.500 ₺" value={pack.price || ""} onChange={(event) => updatePackage(index, "price", event.target.value)} data-testid={`package-price-input-${index + 1}`} /></label>
            <label>Taksit bilgisi<input placeholder="Örn. 6 aya kadar taksit" value={pack.installment_text || ""} onChange={(event) => updatePackage(index, "installment_text", event.target.value)} data-testid={`package-installment-input-${index + 1}`} /></label>
          </div>
          <label>İçerik maddeleri<textarea value={pack.items.join("\n")} onChange={(event) => updatePackage(index, "items", event.target.value.split("\n").filter(Boolean))} data-testid={`package-items-input-${index + 1}`} /></label>
        </article>
      ))}
      <button onClick={onSave} disabled={saving} className="admin-save" data-testid="save-packages-button">Paketleri kaydet</button>
    </div>
  );
}